import React from 'react';

function Demos() {
  return (
    <div>
        Welcome to Demos Component.
    </div>
  );
}

export default Demos;
